import { Box, Typography, Button, Slide } from '@mui/material'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { momentAdapter } from 'src/adapters'
import { NotificationData, NotificationDataType } from 'src/api'

interface Props {
  notification: NotificationData
  icon: ReactElement
  onNotificationOpen: (notification: NotificationData) => void
  onNotificationClose: (notification: NotificationData) => void
  containerEl: Element
}

const NotificationCard: ReactFC<Props> = ({
  notification,
  icon,
  onNotificationOpen,
  onNotificationClose,
  containerEl
}) => {
  const { t } = useTranslation()
  const [mounted, setMounted] = useState(true)
  const handleNotificationClose = () => {
    setMounted(false)
    setTimeout(() => {
      onNotificationClose(notification)
    }, 300)
  }
  return (
    <Slide
      in={mounted}
      direction='left'
      appear={false}
      container={containerEl}
      timeout={300}
    >
      <Box
        key={notification.id}
        sx={{
          padding: '1.5rem .5rem',
          display: 'flex'
        }}
      >
        <Box
          sx={{
            '& > img': {
              transform: 'translateY(-26%)'
            }
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography component='span'>{notification.title}</Typography>
          <Box
            sx={{
              display: 'flex',
              marginTop: '1rem'
            }}
          >
            <Box
              sx={{
                width: '4px',
                minWidth: '4px',
                background: '#DDDEE1',
                borderRadius: 5
              }}
            />
            <Box
              sx={{
                marginLeft: '1rem'
              }}
            >
              {notification.type === NotificationDataType.ReservasSinAsignar ? (
                <Box
                  sx={{
                    '& > *': {
                      fontWeight: 500
                    },
                    '& > *:not(:first-of-type)': {
                      marginTop: '.5rem'
                    }
                  }}
                >
                  <Typography>
                    {'Localizador: '}
                    <Typography component='span'>
                      {notification.identifier}
                    </Typography>
                  </Typography>
                  <Typography>
                    {'Establecimiento: '}
                    <Typography component='span'>
                      {notification.hotelName}
                    </Typography>
                  </Typography>
                  <Typography>
                    {'Tipo: '}
                    <Typography component='span'>
                      {notification.roomTypeName}
                    </Typography>
                  </Typography>
                  <Typography>
                    {'Canal: '}
                    <Typography component='span'>
                      {notification.channelName}
                    </Typography>
                  </Typography>
                </Box>
              ) : (
                <Typography>{notification.message}</Typography>
              )}
            </Box>
          </Box>
          <Typography
            component='span'
            sx={{
              color: 'text.secondary',
              marginTop: '.5rem',
              display: 'inline-block'
            }}
          >
            {momentAdapter.stringDateTimeToMoment(notification.date).fromNow()}
          </Typography>
          <Box
            sx={{
              marginTop: '1rem'
            }}
          >
            <Button
              color={
                notification.type === NotificationDataType.Alertas
                  ? 'error'
                  : 'primary'
              }
              variant='contained'
              sx={{
                padding: '.25rem 2rem'
              }}
              onClick={() => onNotificationOpen(notification)}
            >
              {t('buttons.Open')}
            </Button>
            <Button
              color={
                notification.type === NotificationDataType.Alertas
                  ? 'error'
                  : 'primary'
              }
              variant='outlined'
              sx={{
                padding: '.25rem 2rem',
                marginLeft: '1rem'
              }}
              onClick={handleNotificationClose}
            >
              {notification.type === NotificationDataType.Alertas
                ? t('buttons.Close_alert')
                : t('buttons.Close_notification')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Slide>
  )
}
export default NotificationCard
